module.exports = __webpack_public_path__ + "static/media/tech_bg_img.b6e5954f.png";